import { render, staticRenderFns } from "./exchangeStore.vue?vue&type=template&id=077915e3&"
import script from "./exchangeStore.vue?vue&type=script&lang=js&"
export * from "./exchangeStore.vue?vue&type=script&lang=js&"
import style0 from "./exchangeStore.vue?vue&type=style&index=0&id=077915e3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports